import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchQuery } from 'config/amber-relay';
import graphql from 'babel-plugin-relay/macro'

export const SystemConfigContext = createContext();

export const SystemConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        setLoading(true);
        const query = graphql`
          query SystemConfigContextQuery {
            SystemConfig {
              OnuApi
            }
          }
        `;
        const result = await fetchQuery(query);
        setConfig(result.SystemConfig);
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error('Error fetching system config:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  return (
    <SystemConfigContext.Provider value={{ config, loading, error }}>
      {children}
    </SystemConfigContext.Provider>
  );
};

export default SystemConfigProvider